/**
 * FUND.
 */
export const FUND_OUTPUT_REQUEST = 'FUND_OUTPUT_REQUEST';
export const FUND_OUTPUT_RECEIVE = 'FUND_OUTPUT_RECEIVE';
export const FUND_OUTPUT_FILTER_STATE = 'FUND_OUTPUT_FILTER_STATE';
export const FUND_OUTPUT_DETAIL_REQUEST = 'FUND_OUTPUT_DETAIL_REQUEST';
export const FUND_OUTPUT_DETAIL_RECEIVE = 'FUND_OUTPUT_DETAIL_RECEIVE';
export const FUND_OUTPUT_DETAIL_CLEAR = 'FUND_OUTPUT_DETAIL_CLEAR';
export const FUND_OUTPUT_SELECT_OUTPUT = 'FUND_OUTPUT_SELECT_OUTPUT';

export const FUND_OUTPUT_FILES_REQUEST = 'FUND_OUTPUT_FILES_REQUEST';
export const FUND_OUTPUT_FILES_RECEIVE = 'FUND_OUTPUT_FILES_RECEIVE';
export const FUND_OUTPUT_FILES_FILTER = 'FUND_OUTPUT_FILES_FILTER';

export const FUND_OUTPUT_FUNCTIONS_REQUEST = 'FUND_OUTPUT_FUNCTIONS_REQUEST';
export const FUND_OUTPUT_FUNCTIONS_RECEIVE = 'FUND_OUTPUT_FUNCTIONS_RECEIVE';
export const FUND_OUTPUT_FUNCTIONS_FILTER = 'FUND_OUTPUT_FUNCTIONS_FILTER';

export const FUND_EXTENDED_VIEW = 'FUND_EXTENDED_VIEW';

export const FUND_INVALID = 'FUND_INVALID';

export const FUND_FUNDS_RECEIVE = 'FUND_FUNDS_RECEIVE';
export const FUND_FUNDS_REQUEST = 'FUND_FUNDS_REQUEST';
export const FUND_NODES_RECEIVE = 'FUND_NODES_RECEIVE';
export const FUND_NODES_REQUEST = 'FUND_NODES_REQUEST';

export const USERS_SEARCH = 'USERS_SEARCH';
export const USERS_REQUEST = 'USERS_REQUEST';
export const USERS_RECEIVE = 'USERS_RECEIVE';
export const USERS_SELECT_USER = 'USERS_SELECT_USER';
export const USERS_USER_DETAIL_REQUEST = 'USERS_USER_DETAIL_REQUEST';
export const USERS_USER_DETAIL_RECEIVE = 'USERS_USER_DETAIL_RECEIVE';

export const PERMISSIONS_PERMISSION_CHANGE = 'PERMISSIONS_PERMISSION_CHANGE';
export const PERMISSIONS_PERMISSION_ADD = 'PERMISSIONS_PERMISSION_ADD';
export const PERMISSIONS_PERMISSION_REMOVE = 'PERMISSIONS_PERMISSION_REMOVE';
export const PERMISSIONS_PERMISSION_RECEIVE = 'PERMISSIONS_PERMISSION_RECEIVE';

export const GROUP_DELETE = 'GROUP_DELETE';
export const GROUPS_SEARCH = 'GROUPS_SEARCH';
export const GROUPS_REQUEST = 'GROUPS_REQUEST';
export const GROUPS_RECEIVE = 'GROUPS_RECEIVE';
export const GROUPS_SELECT_GROUP = 'GROUPS_SELECT_GROUP';
export const GROUPS_GROUP_DETAIL_REQUEST = 'GROUPS_GROUP_DETAIL_REQUEST';
export const GROUPS_GROUP_DETAIL_RECEIVE = 'GROUPS_GROUP_DETAIL_RECEIVE';

export const FUNDS_SEARCH = 'FUNDS_SEARCH';
export const FUNDS_FILTER = 'FUNDS_FILTER';
export const FUNDS_REQUEST = 'FUNDS_REQUEST';
export const FUNDS_RECEIVE = 'FUNDS_RECEIVE';
export const FUNDS_FUND_DETAIL_REQUEST = 'FUNDS_FUND_DETAIL_REQUEST';
export const FUNDS_FUND_DETAIL_RECEIVE = 'FUNDS_FUND_DETAIL_RECEIVE';
export const FUNDS_SELECT_FUND = 'FUNDS_SELECT_FUND';

export const FUND_PACKETS_REQUEST = 'FUND_PACKETS_REQUEST';
export const FUND_PACKETS_RECEIVE = 'FUND_PACKETS_RECEIVE';
export const FUND_PACKETS_FILTER = 'FUND_PACKETS_FILTER';
export const FUND_PACKETS_CHANGE_SELECTION = 'FUND_PACKETS_CHANGE_SELECTION';

export const FUND_FILES_REQUEST = 'FUND_FILES_REQUEST';
export const FUND_FILES_RECEIVE = 'FUND_FILES_RECEIVE';
export const FUND_FILES_FILTER = 'FUND_FILES_FILTER';
export const FUND_NODE_INCREASE_VERSION = 'FUND_NODE_INCREASE_VERSION';
export const FUND_FUND_CHANGE_READ_MODE = 'FUND_FUND_CHANGE_READ_MODE';
export const FUND_FUND_TREE_REQUEST = 'FUND_FUND_TREE_REQUEST';
export const FUND_FUND_TREE_RECEIVE = 'FUND_FUND_TREE_RECEIVE';
export const FUND_FUND_TREE_EXPAND_NODE = 'FUND_FUND_TREE_EXPAND_NODE';
export const FUND_FUND_TREE_COLLAPSE_NODE = 'FUND_FUND_TREE_COLLAPSE_NODE';
export const FUND_FUND_TREE_FOCUS_NODE = 'FUND_FUND_TREE_FOCUS_NODE';
export const FUND_FUND_TREE_COLLAPSE = 'FUND_FUND_TREE_COLLAPSE';
export const FUND_FUND_TREE_SELECT_NODE = 'FUND_FUND_TREE_SELECT_NODE';
export const FUND_FUND_TREE_FULLTEXT_CHANGE = 'FUND_FUND_TREE_FULLTEXT_CHANGE';
export const FUND_FUND_TREE_CONFIGURE = 'FUND_FUND_TREE_CONFIGURE';
export const FUND_FUND_TREE_FULLTEXT_RESULT = 'FUND_FUND_TREE_FULLTEXT_RESULT';
export const FUND_TREE_AREA_FUNDS_FUND_DETAIL = 'FUND_TREE_AREA_FUNDS_FUND_DETAIL';
export const FUND_TREE_AREA_MAIN = 'FUND_TREE_AREA_MAIN';
export const FUND_TREE_AREA_MOVEMENTS_LEFT = 'FUND_TREE_AREA_MOVEMENTS_LEFT';
export const FUND_TREE_AREA_MOVEMENTS_RIGHT = 'FUND_TREE_AREA_MOVEMENTS_RIGHT';
export const FUND_TREE_AREA_DAOS_LEFT = 'FUND_TREE_AREA_DAOS_LEFT';
export const FUND_TREE_AREA_DAOS_RIGHT = 'FUND_TREE_AREA_DAOS_RIGHT';
export const FUND_TREE_AREA_NODES = 'FUND_TREE_AREA_NODES';
export const FUND_TREE_AREA_ALL = 'FUND_TREE_AREA_ALL';

export const CUSTOM_FUND_TREE_AREA_NODES = 'CUSTOM_FUND_TREE_AREA_NODES';
export const CUSTOM_FUND_ACTION_SELECT_VERSION = 'CUSTOM_FUND_ACTION_SELECT_VERSION';

export const FUND_TREE_AREA_COPY = 'FUND_TREE_AREA_COPY';

export const FUND_TREE_AREA_USAGE = 'FUND_TREE_AREA_USAGE';

export const FUND_FUND_TREE_INVALIDATE = 'FUND_FUND_TREE_INVALIDATE';

export const SELECT_FUND_GLOBAL = 'SELECT_FUND_GLOBAL';

export const FUND_SUB_NODE_INFO_REQUEST = 'FUND_SUB_NODE_INFO_REQUEST';
export const FUND_SUB_NODE_INFO_RECEIVE = 'FUND_SUB_NODE_INFO_RECEIVE';

export const FUND_SUB_NODE_REGISTER_RECEIVE = 'FUND_SUB_NODE_REGISTER_RECEIVE';
export const FUND_SUB_NODE_REGISTER_REQUEST = 'FUND_SUB_NODE_REGISTER_REQUEST';
export const FUND_SUB_NODE_REGISTER_VALUE_ADD = 'FUND_SUB_NODE_REGISTER_VALUE_ADD';
export const FUND_SUB_NODE_REGISTER_VALUE_FOCUS = 'FUND_SUB_NODE_REGISTER_VALUE_FOCUS';
export const FUND_SUB_NODE_REGISTER_VALUE_CHANGE = 'FUND_SUB_NODE_REGISTER_VALUE_CHANGE';
export const FUND_SUB_NODE_REGISTER_VALUE_BLUR = 'FUND_SUB_NODE_REGISTER_VALUE_BLUR';
export const FUND_SUB_NODE_REGISTER_VALUE_DELETE = 'FUND_SUB_NODE_REGISTER_VALUE_DELETE';
export const FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_CREATE = 'FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_CREATE';
export const FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_DELETE = 'FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_DELETE';
export const FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_UPDATE = 'FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_UPDATE';
export const FUND_SUB_NODE_REGISTER_VALUE_SAVING = 'FUND_SUB_NODE_REGISTER_VALUE_SAVING';

export const FUND_SUB_NODE_DAOS_RECEIVE = 'FUND_SUB_NODE_DAOS_RECEIVE';
export const FUND_SUB_NODE_DAOS_REQUEST = 'FUND_SUB_NODE_DAOS_REQUEST';

export const FUND_SUB_NODE_FORM_REQUEST = 'FUND_SUB_NODE_FORM_REQUEST';
export const FUND_SUB_NODE_FORM_RECEIVE = 'FUND_SUB_NODE_FORM_RECEIVE';
export const FUND_SUB_NODE_FORM_VALUE_CREATE = 'FUND_SUB_NODE_FORM_VALUE_CREATE';
export const FUND_SUB_NODE_FORM_VALUE_CHANGE = 'FUND_SUB_NODE_FORM_VALUE_CHANGE';
export const FUND_SUB_NODE_FORM_VALUE_CHANGE_POSITION = 'FUND_SUB_NODE_FORM_VALUE_CHANGE_POSITION';
export const FUND_SUB_NODE_FORM_VALUE_CHANGE_RECORD = 'FUND_SUB_NODE_FORM_VALUE_CHANGE_RECORD';
export const FUND_SUB_NODE_FORM_VALUE_CHANGE_SPEC = 'FUND_SUB_NODE_FORM_VALUE_CHANGE_SPEC';
export const FUND_SUB_NODE_FORM_VALUE_VALIDATE_RESULT = 'FUND_SUB_NODE_FORM_VALUE_VALIDATE_RESULT';
export const FUND_SUB_NODE_FORM_VALUE_BLUR = 'FUND_SUB_NODE_FORM_VALUE_BLUR';
export const FUND_SUB_NODE_FORM_VALUE_FOCUS = 'FUND_SUB_NODE_FORM_VALUE_FOCUS';
export const FUND_SUB_NODE_FORM_VALUE_ADD = 'FUND_SUB_NODE_FORM_VALUE_ADD';
export const FUND_SUB_NODE_FORM_VALUE_NOT_IDENTIFIED = 'FUND_SUB_NODE_FORM_VALUE_NOT_IDENTIFIED';
export const FUND_SUB_NODE_FORM_VALUE_DELETE = 'FUND_SUB_NODE_FORM_VALUE_DELETE';
export const FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_DELETE = 'FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_DELETE';
export const FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_ADD = 'FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_ADD';
export const FUND_TEMPLATE_USE = 'FUND_TEMPLATE_USE';
export const FUND_SUB_NODE_FORM_VALUE_RESPONSE = 'FUND_SUB_NODE_FORM_VALUE_RESPONSE';
export const FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_COPY_FROM_PREV_RESPONSE =
    'FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_COPY_FROM_PREV_RESPONSE';
export const FUND_SUB_NODE_FORM_OUTPUT_CALC_SWITCH = 'FUND_SUB_NODE_FORM_OUTPUT_CALC_SWITCH';

export const FUND_FUND_DATA_GRID_INIT = 'FUND_FUND_DATA_GRID_INIT';
export const FUND_FUND_DATA_GRID_FILTER = 'FUND_FUND_DATA_GRID_FILTER';
export const FUND_FUND_DATA_GRID_FULLTEXT_RESULT = 'FUND_FUND_DATA_GRID_FULLTEXT_RESULT';
export const FUND_FUND_DATA_GRID_FULLTEXT_CLEAR = 'FUND_FUND_DATA_GRID_FULLTEXT_CLEAR';
export const FUND_FUND_DATA_GRID_FULLTEXT_EXTENDED = 'FUND_FUND_DATA_GRID_FULLTEXT_EXTENDED';
export const FUND_FUND_DATA_GRID_FULLTEXT_NEXT_ITEM = 'FUND_FUND_DATA_GRID_FULLTEXT_NEXT_ITEM';
export const FUND_FUND_DATA_GRID_FULLTEXT_PREV_ITEM = 'FUND_FUND_DATA_GRID_FULLTEXT_PREV_ITEM';
export const FUND_FUND_DATA_GRID_FILTER_REQUEST = 'FUND_FUND_DATA_GRID_FILTER_REQUEST';
export const FUND_FUND_DATA_GRID_FILTER_RECEIVE = 'FUND_FUND_DATA_GRID_FILTER_RECEIVE';
export const FUND_FUND_DATA_GRID_FILTER_CHANGE = 'FUND_FUND_DATA_GRID_FILTER_CHANGE';
export const FUND_FUND_DATA_GRID_FILTER_SET = 'FUND_FUND_DATA_GRID_FILTER_SET';
export const FUND_FUND_DATA_GRID_FILTER_CLEAR_ALL = 'FUND_FUND_DATA_GRID_FILTER_CLEAR_ALL';
export const FUND_FUND_DATA_GRID_PREPARE_EDIT = 'FUND_FUND_DATA_GRID_PREPARE_EDIT';
export const FUND_FUND_DATA_GRID_DATA_REQUEST = 'FUND_FUND_DATA_GRID_DATA_REQUEST';
export const FUND_FUND_DATA_GRID_DATA_RECEIVE = 'FUND_FUND_DATA_GRID_DATA_RECEIVE';
export const FUND_FUND_DATA_GRID_DATA_ERROR = 'FUND_FUND_DATA_GRID_DATA_ERROR';
export const FUND_FUND_DATA_GRID_COLUMN_SIZE = 'FUND_FUND_DATA_GRID_COLUMN_SIZE';
export const FUND_FUND_DATA_GRID_COLUMNS_SETTINGS = 'FUND_FUND_DATA_GRID_COLUMNS_SETTINGS';

export const FUND_FUND_NODES_POLICY_REQUEST = 'FUND_FUND_NODES_POLICY_REQUEST';
export const FUND_FUND_NODES_POLICY_RECEIVE = 'FUND_FUND_NODES_POLICY_RECEIVE';

export const FUND_NODE_INFO_REQUEST = 'FUND_NODE_INFO_REQUEST';
export const FUND_NODE_INFO_RECEIVE = 'FUND_NODE_INFO_RECEIVE';
export const FUND_NODE_INFO_INVALIDATE = 'FUND_NODE_INFO_INVALIDATE';

export const FUND_SELECT_FUND_TAB = 'FUND_SELECT_FUND_TAB';
export const FUND_CLOSE_FUND_TAB = 'FUND_CLOSE_FUND_TAB';

export const FUND_SEARCH_FULLTEXT_CHANGE = 'FUND_SEARCH_FULLTEXT_CHANGE';
export const FUND_SEARCH_FULLTEXT_REQUEST = 'FUND_SEARCH_FULLTEXT_REQUEST';
export const FUND_SEARCH_FULLTEXT_RECEIVE = 'FUND_SEARCH_FULLTEXT_RECEIVE';
export const FUND_SEARCH_EXPAND_FUND = 'FUND_SEARCH_EXPAND_FUND';
export const FUND_SEARCH_FUND_REQUEST = 'FUND_SEARCH_FUND_REQUEST';
export const FUND_SEARCH_FUND_RECEIVE = 'FUND_SEARCH_FUND_RECEIVE';

export const FUND_FUND_SELECT_NODE_TAB = 'FUND_FUND_SELECT_NODE_TAB';
export const FUND_FUND_CLOSE_NODE_TAB = 'FUND_FUND_CLOSE_NODE_TAB';
export const FUND_FUND_SELECT_SUBNODE = 'FUND_FUND_SELECT_SUBNODE';
export const FUND_FUND_SUBNODES_NEXT = 'FUND_FUND_SUBNODES_NEXT';
export const FUND_FUND_SUBNODES_PREV = 'FUND_FUND_SUBNODES_PREV';
export const FUND_FUND_SUBNODES_NEXT_PAGE = 'FUND_FUND_SUBNODES_NEXT_PAGE';
export const FUND_FUND_SUBNODES_PREV_PAGE = 'FUND_FUND_SUBNODES_PREV_PAGE';
export const FUND_FUND_SUBNODES_FULLTEXT_SEARCH = 'FUND_FUND_SUBNODES_FULLTEXT_SEARCH';
export const FUND_FUND_SUBNODES_FULLTEXT_RESULT = 'FUND_FUND_SUBNODES_FULLTEXT_RESULT';
export const FUND_FUND_APPROVE_VERSION = 'FUND_FUND_APPROVE_VERSION';

/**
 * Uživatelské nastavení pro JP
 */
export const NODE_DESC_ITEM_TYPE_LOCK = 'NODE_DESC_ITEM_TYPE_LOCK';
export const NODE_DESC_ITEM_TYPE_UNLOCK = 'NODE_DESC_ITEM_TYPE_UNLOCK';
export const NODE_DESC_ITEM_TYPE_UNLOCK_ALL = 'NODE_DESC_ITEM_TYPE_UNLOCK_ALL';
export const NODE_DESC_ITEM_COPY_ALL = 'NODE_DESC_ITEM_COPY_ALL';
export const NODE_DESC_ITEM_TYPE_COPY_ALL = 'NODE_DESC_ITEM_TYPE_COPY_ALL';
export const NODE_DESC_ITEM_TYPE_COPY = 'NODE_DESC_ITEM_TYPE_COPY';
export const NODE_DESC_ITEM_TYPE_NOCOPY = 'NODE_DESC_ITEM_TYPE_NOCOPY';
export const SHOW_REGISTER_JP = 'SHOW_REGISTER_JP';

/**
 * Přihlášený uživatel a jeho informace.
 */
export const USER_DETAIL_CHANGE = 'USER_DETAIL_CHANGE';
export const USER_DETAIL_REQUEST = 'USER_DETAIL_REQUEST';
export const USER_DETAIL_REQUEST_SETTINGS = 'USER_DETAIL_REQUEST_SETTINGS';
export const USER_DETAIL_RESPONSE_SETTINGS = 'USER_DETAIL_RESPONSE_SETTINGS';
export const USER_DETAIL_CLEAR = 'USER_DETAIL_CLEAR';

/**
 * JP akce
 */
export const FUND_NODE_CHANGE = 'FUND_NODE_CHANGE';

/**
 * Obaly pro FUND
 */
export const PACKETS_REQUEST = 'PACKETS_REQUEST';
export const PACKETS_RECEIVE = 'PACKETS_RECEIVE';
export const CHANGE_PACKETS = 'CHANGE_PACKETS';
export const CHANGE_FILES = 'CHANGE_FILES';

/**
 * Toastr
 **/

export const TOASTR_ADD = 'TOASTR_ADD';
export const TOASTR_REMOVE = 'TOASTR_REMOVE';

/**
 * Registry.
 */

export const REGISTRY_ARR_RESET = 'REGISTRY_ARR_RESET';
export const REGISTRY_CLEAR_SEARCH = 'REGISTRY_CLEAR_SEARCH';
export const REGISTRY_RELOAD_NAVIGATION = 'REGISTRY_RELOAD_NAVIGATION';
export const REGISTRY_LIST_REQUEST = 'REGISTRY_LIST_REQUEST';
export const REGISTRY_LIST_RECEIVE = 'REGISTRY_LIST_RECEIVE';
export const REGISTRY_SELECT = 'REGISTRY_SELECT';
export const REGISTRY_CHANGED_TYPES_ID = 'REGISTRY_CHANGED_TYPES_ID';
export const REGISTRY_RECORD_SELECT = 'REGISTRY_RECORD_SELECT';
export const REGISTRY_RECORD_SEARCH = 'REGISTRY_RECORD_SEARCH';
export const REGISTRY_RECORD_DETAIL_RECEIVE = 'REGISTRY_RECORD_DETAIL_RECEIVE';
export const REGISTRY_RECORD_DETAIL_REQUEST = 'REGISTRY_RECORD_DETAIL_REQUEST';
export const REGISTRY_RECORD_DETAIL_CHANGE = 'REGISTRY_RECORD_DETAIL_CHANGE';
export const REGISTRY_RECORD_DETAIL_CLEAR = 'REGISTRY_RECORD_DETAIL_CLEAR';
export const REGISTRY_RECORD_UPDATED = 'REGISTRY_RECORD_UPDATED';
export const REGISTRY_RECORD_REMOVE = 'REGISTRY_RECORD_REMOVE';
export const REGISTRY_RECORD_NOTE_UPDATED = 'REGISTRY_RECORD_NOTE_UPDATED';
export const REGISTRY_RECORD_TYPES_REQUEST = 'REGISTRY_RECORD_TYPES_REQUEST';
export const REGISTRY_RECORD_TYPES_RECEIVE = 'REGISTRY_RECORD_TYPES_RECEIVE';

/**
 * Global.
 */
export const GLOBAL_GET_OBJECT_INFO = 'GLOBAL_GET_OBJECT_INFO';
export const GLOBAL_CONTEXT_MENU_SHOW = 'GLOBAL_CONTEXT_MENU_SHOW';
export const GLOBAL_CONTEXT_MENU_HIDE = 'GLOBAL_CONTEXT_MENU_HIDE';
export const GLOBAL_MODAL_DIALOG_SHOW = 'GLOBAL_MODAL_DIALOG_SHOW';
export const GLOBAL_MODAL_DIALOG_HIDE = 'GLOBAL_MODAL_DIALOG_HIDE';
export const GLOBAL_INIT_FORM_DATA = 'GLOBAL_INIT_FORM_DATA';
export const GLOBAL_WEB_SOCKET_CONNECT = 'GLOBAL_WEB_SOCKET_CONNECT';
export const GLOBAL_WEB_SOCKET_DISCONNECT = 'GLOBAL_WEB_SOCKET_DISCONNECT';
export const GLOBAL_SPLITTER_RESIZE = 'GLOBAL_SPLITTER_RESIZE';

export const SET_FOCUS = 'SET_FOCUS';

export const DEVELOPER_SET = 'DEVELOPER_SET';
export const DEVELOPER_SCENARIOS_RECEIVED = 'DEVELOPER_SCENARIOS_RECEIVED';
export const DEVELOPER_SCENARIOS_FETCHING = 'DEVELOPER_SCENARIOS_FETCHING';
export const DEVELOPER_SCENARIOS_DIRTY = 'DEVELOPER_SCENARIOS_DIRTY';

/**
 * Ukládání a načítání store.
 */
export const STORE_SAVE = 'STORE_SAVE';
export const STORE_LOAD = 'STORE_LOAD';
export const STORE_STATE_DATA = 'STORE_STATE_DATA';
export const STORE_STATE_DATA_INIT = 'STORE_STATE_DATA_INIT';

/**
 * scopes
 */
export const SCOPES_PREPARE_SCOPES_DATE = 'SCOPES_PREPARE_SCOPES_DATE';
/**
 * Router.
 */
export const ROUTER_NAVIGATE = 'ROUTER_NAVIGATE';
export const ROUTER_NAVIGATE_CLEAR = 'ROUTER_NAVIGATE_CLEAR';

/**
 * Admin - Packages
 */
export const ADMIN_PACKAGES_REQUEST = 'ADMIN_PACKAGES_REQUEST'; // dotaz na načtení balíčků
export const ADMIN_PACKAGES_RECEIVE = 'ADMIN_PACKAGES_RECEIVE'; // odpověď na načtení balíčků
export const ADMIN_PACKAGES_DELETE_REQUEST = 'ADMIN_PACKAGES_DELETE_REQUEST'; // dotaz na smazání balíčku
export const ADMIN_PACKAGES_DELETE_RECEIVE = 'ADMIN_PACKAGES_DELETE_RECEIVE'; // odpověď na smazání balíčku
export const ADMIN_PACKAGES_IMPORT_REQUEST = 'ADMIN_PACKAGES_IMPORT_REQUEST'; // dotaz na nahrání balíčku
export const ADMIN_PACKAGES_IMPORT_RECEIVE = 'ADMIN_PACKAGES_IMPORT_RECEIVE'; // odpověď na nahrání balíčku

/**
 * Admin - Fulltext
 */
export const ADMIN_FULLTEXT_REINDEXING_REQUEST = 'ADMIN_FULLTEXT_REINDEXING_REQUEST'; // požadavek na reindexace
export const ADMIN_FULLTEXT_REINDEXING_STATE_REQUEST = 'ADMIN_FULLTEXT_REINDEXING_STATE_REQUEST'; // dotaz na průběh indexace
export const ADMIN_FULLTEXT_REINDEXING_STATE_RECEIVE = 'ADMIN_FULLTEXT_REINDEXING_STATE_RECEIVE'; // odpověď na průběh indexace

/**
 * Ref tables.
 */
export const REF_RULE_SET_REQUEST = 'REF_RULE_SET_REQUEST';
export const REF_RULE_SET_RECEIVE = 'REF_RULE_SET_RECEIVE';
export const REF_INSTITUTIONS_REQUEST = 'REF_INSTITUTIONS_REQUEST';
export const REF_INSTITUTIONS_RECEIVE = 'REF_INSTITUTIONS_RECEIVE';
export const REF_RUL_DATA_TYPES_REQUEST = 'REF_RUL_DATA_TYPES_REQUEST';
export const REF_RUL_DATA_TYPES_RECEIVE = 'REF_RUL_DATA_TYPES_RECEIVE';
export const REF_RECORD_TYPES_REQUEST = 'REF_RECORD_TYPES_REQUEST';
export const REF_RECORD_TYPES_RECEIVE = 'REF_RECORD_TYPES_RECEIVE';
export const REF_CALENDAR_TYPES_REQUEST = 'REF_CALENDAR_TYPES_REQUEST';
export const REF_CALENDAR_TYPES_RECEIVE = 'REF_CALENDAR_TYPES_RECEIVE';
export const REF_TEMPLATES_REQUEST = 'REF_TEMPLATES_REQUEST';
export const REF_TEMPLATES_RECEIVE = 'REF_TEMPLATES_RECEIVE';
export const REF_PACKET_TYPES_REQUEST = 'REF_PACKET_TYPES_REQUEST';
export const REF_PACKET_TYPES_RECEIVE = 'REF_PACKET_TYPES_RECEIVE';
export const REF_REGISTER_TYPES_REQUEST = 'REF_REGISTER_TYPES_REQUEST';
export const REF_REGISTER_TYPES_RECEIVE = 'REF_REGISTER_TYPES_RECEIVE';
export const REF_SCOPES_TYPES_REQUEST = 'REF_SCOPES_TYPES_REQUEST';
export const REF_SCOPES_TYPES_RECEIVE = 'REF_SCOPES_TYPES_RECEIVE';
export const REF_SCOPES_TYPES_FETCHING = 'REF_SCOPES_TYPES_FETCHING';
export const REF_SCOPES_TYPES_DIRTY = 'REF_SCOPES_TYPES_DIRTY';
export const REF_DESC_ITEM_TYPES_REQUEST = 'REF_DESC_ITEM_TYPES_REQUEST';
export const REF_DESC_ITEM_TYPES_RECEIVE = 'REF_DESC_ITEM_TYPES_RECEIVE';
export const REF_VISIBLE_POLICY_TYPES_REQUEST = 'REF_VISIBLE_POLICY_TYPES_REQUEST';
export const REF_VISIBLE_POLICY_TYPES_RECEIVE = 'REF_VISIBLE_POLICY_TYPES_RECEIVE';
export const REF_OUTPUT_TYPES_RECEIVE = 'REF_OUTPUT_TYPES_RECEIVE';
export const REF_OUTPUT_TYPES_REQUEST = 'REF_OUTPUT_TYPES_REQUEST';
export const REF_EXTERNAL_SYSTEMS_RECEIVE = 'REF_EXTERNAL_SYSTEMS_RECEIVE';
export const REF_EXTERNAL_SYSTEMS_REQUEST = 'REF_EXTERNAL_SYSTEMS_REQUEST';
export const REF_EXTERNAL_SYSTEMS_INVALID = 'REF_EXTERNAL_SYSTEMS_INVALID';

export const REF_STRUCTURE_TYPES_DIRTY = 'REF_STRUCTURE_TYPES_DIRTY';
export const REF_STRUCTURE_TYPES_FETCHING = 'REF_STRUCTURE_TYPES_FETCHING';
export const REF_STRUCTURE_TYPES_RECEIVE = 'REF_STRUCTURE_TYPES_RECEIVE';

export const REF_AP_TYPES_REQUEST = 'REF_AP_TYPES_REQUEST';
export const REF_AP_TYPES_RECEIVE = 'REF_AP_TYPES_RECEIVE';

export const REF_PART_TYPES_REQUEST = 'REF_PART_TYPES_REQUEST';
export const REF_PART_TYPES_RECEIVE = 'REF_PART_TYPES_RECEIVE';

/**
 * Akce od websocketů.
 */
export const FUND_SUBNODE_UPDATE = 'FUND_SUBNODE_UPDATE';
export const CHANGE_NODE_REQUESTS = 'CHANGE_NODE_REQUESTS';
export const CHANGE_CONFORMITY_INFO = 'CHANGE_CONFORMITY_INFO';
export const CHANGE_INDEXING_FINISHED = 'CHANGE_INDEXING_FINISHED';
export const CHANGE_PACKAGE = 'CHANGE_PACKAGE';
export const CHANGE_INSTITUTION = 'CHANGE_INSTITUTION';
export const CHANGE_NODES = 'CHANGE_NODES';
export const CHANGE_OUTPUTS = 'CHANGE_OUTPUTS';
export const CHANGE_STRUCTURE = 'CHANGE_STRUCTURE';
export const CHANGE_FUND_ACTION = 'CHANGE_FUND_ACTION';
export const CHANGE_DELETE_LEVEL = 'CHANGE_DELETE_LEVEL';
export const CHANGE_ADD_LEVEL = 'CHANGE_ADD_LEVEL';
export const CHANGE_APPROVE_VERSION = 'CHANGE_APPROVE_VERSION';
export const CHANGE_MOVE_LEVEL = 'CHANGE_MOVE_LEVEL';
export const FUND_NODES_MOVE_START = 'FUND_NODES_MOVE_START';
export const FUND_NODES_MOVE_STOP = 'FUND_NODES_MOVE_STOP';
export const CHANGE_REGISTRY_UPDATE = 'CHANGE_REGISTRY_UPDATE';
export const CHANGE_FUND = 'CHANGE_FUND';
export const CHANGE_FUND_RECORD = 'CHANGE_FUND_RECORD';
export const CHANGE_VISIBLE_POLICY = 'CHANGE_VISIBLE_POLICY';
export const CHANGE_USER = 'CHANGE_USER';
export const CHANGE_GROUP = 'CHANGE_GROUP';

export const DELETE_FUND = 'DELETE_FUND';

/**
 * Output related actions
 */
export const OUTPUT_CHANGES = 'OUTPUT_CHANGES';
export const OUTPUT_CHANGES_DETAIL = 'OUTPUT_CHANGES_DETAIL';
export const OUTPUT_INCREASE_VERSION = 'OUTPUT_INCREASE_VERSION';
export const OUTPUT_STATE_CHANGE = 'OUTPUT_STATE_CHANGE';

/**
 * Bulk Actions
 */
export const BULK_ACTIONS_DATA_LOADING = 'BULK_ACTIONS_DATA_LOADING';
export const BULK_ACTIONS_RECEIVED_DATA = 'BULK_ACTIONS_RECEIVED_DATA';
export const BULK_ACTIONS_VERSION_VALIDATE_RECEIVED_DATA = 'BULK_ACTIONS_VERSION_VALIDATE_RECEIVED_DATA';
export const BULK_ACTIONS_RECEIVED_STATE = 'BULK_ACTIONS_RECEIVED_STATE';
export const BULK_ACTIONS_STATE_CHANGE = 'BULK_ACTIONS_STATE_CHANGE';
export const BULK_ACTIONS_STATE_IS_DIRTY = 'BULK_ACTIONS_STATE_IS_DIRTY';

/**
 * Fund actions
 */
export const FUND_ACTION_ACTION_SELECT = 'FUND_ACTION_ACTION_SELECT';
export const FUND_ACTION_CONFIG_REQUEST = 'FUND_ACTION_CONFIG_REQUEST';
export const FUND_ACTION_CONFIG_RECEIVE = 'FUND_ACTION_CONFIG_RECEIVE';
export const FUND_ACTION_ACTION_DETAIL_REQUEST = 'FUND_ACTION_ACTION_DETAIL_REQUEST';
export const FUND_ACTION_ACTION_DETAIL_RECEIVE = 'FUND_ACTION_ACTION_DETAIL_RECEIVE';
export const FUND_ACTION_LIST_REQUEST = 'FUND_ACTION_LIST_REQUEST';
export const FUND_ACTION_LIST_RECEIVE = 'FUND_ACTION_LIST_RECEIVE';
export const FUND_ACTION_FORM_SHOW = 'FUND_ACTION_FORM_SHOW';
export const FUND_ACTION_FORM_HIDE = 'FUND_ACTION_FORM_HIDE';
export const FUND_ACTION_FORM_RESET = 'FUND_ACTION_FORM_RESET';
export const FUND_ACTION_FORM_CHANGE = 'FUND_ACTION_FORM_CHANGE';
export const FUND_ACTION_FORM_SUBMIT = 'FUND_ACTION_FORM_SUBMIT';

/**
 *
 */
export const FUND_VERSION_VALIDATION_LOAD = 'FUND_VERSION_VALIDATION_LOAD';
export const FUND_VERSION_VALIDATION_RECEIVED = 'FUND_VERSION_VALIDATION_RECEIVED';
export const FUND_VERSION_VALIDATION_ERROR_NEXT_REQUEST = 'FUND_VERSION_VALIDATION_ERROR_NEXT_REQUEST';
export const FUND_VERSION_VALIDATION_ERROR_NEXT_RECEIVE = 'FUND_VERSION_VALIDATION_ERROR_NEXT_RECEIVE';
export const FUND_VERSION_VALIDATION_ERROR_PREVIOUS_REQUEST = 'FUND_VERSION_VALIDATION_ERROR_PREVIOUS_REQUEST';
export const FUND_VERSION_VALIDATION_ERROR_PREVIOUS_RECEIVE = 'FUND_VERSION_VALIDATION_ERROR_PREVIOUS_RECEIVE';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

export const VISIBLE_POLICY_REQUEST = 'VISIBLE_POLICY_REQUEST';
export const VISIBLE_POLICY_RECEIVE = 'VISIBLE_POLICY_RECEIVE';

export const SET_VISIBLE_POLICY_REQUEST = 'SET_VISIBLE_POLICY_REQUEST';
export const SET_VISIBLE_POLICY_RECEIVE = 'SET_VISIBLE_POLICY_RECEIVE';

/**
 * Záložky
 */
export const TAB_SELECT = 'TAB_SELECT';

/**
 * Status store
 */
export const STATUS_SAVING = 'STATUS_SAVING';
export const STATUS_SAVED = 'STATUS_SAVED';

/**
 * Smazání nodů - při UNDO
 */
export const NODES_DELETE = 'NODES_DELETE';

export const CHANGE_DAOS = 'CHANGE_DAOS';

/**
 * Structure
 */
export const STRUCTURE_NODE_FORM_REQUEST = 'STRUCTURE_NODE_FORM_REQUEST';
export const STRUCTURE_NODE_FORM_RECEIVE = 'STRUCTURE_NODE_FORM_RECEIVE';
export const STRUCTURE_NODE_FORM_SET_DATA = 'STRUCTURE_NODE_FORM_SET_DATA';
export const STRUCTURE_NODE_FORM_SELECT_ID = 'STRUCTURE_NODE_FORM_SELECT_ID';

/**
 * Item form
 */
export const ITEM_FORM_CHANGE_READ_MODE = 'ITEM_FORM_CHANGE_READ_MODE';
export const ITEM_FORM_VALUE_VALIDATE_RESULT = 'ITEM_FORM_VALUE_VALIDATE_RESULT';
export const ITEM_FORM_FORM_VALUE_CHANGE_POSITION = 'ITEM_FORM_FORM_VALUE_CHANGE_POSITION';
export const ITEM_FORM_VALUE_CHANGE = 'ITEM_FORM_VALUE_CHANGE';
export const ITEM_FORM_VALUE_CHANGE_RECORD = 'ITEM_FORM_VALUE_CHANGE_RECORD';
export const ITEM_FORM_VALUE_CHANGE_SPEC = 'ITEM_FORM_VALUE_CHANGE_SPEC';
export const ITEM_FORM_VALUE_BLUR = 'ITEM_FORM_VALUE_BLUR';
export const ITEM_FORM_VALUE_FOCUS = 'ITEM_FORM_VALUE_FOCUS';
export const ITEM_FORM_VALUE_CREATE = 'ITEM_FORM_VALUE_CREATE';
export const ITEM_FORM_VALUE_ADD = 'ITEM_FORM_VALUE_ADD';
export const ITEM_FORM_DESC_ITEM_TYPE_COPY_FROM_PREV_RESPONSE = 'ITEM_FORM_DESC_ITEM_TYPE_COPY_FROM_PREV_RESPONSE';
export const ITEM_FORM_OUTPUT_CALC_SWITCH = 'ITEM_FORM_OUTPUT_CALC_SWITCH';
export const ITEM_FORM_VALUE_RESPONSE = 'ITEM_FORM_VALUE_RESPONSE';
export const ITEM_FORM_TEMPLATE_USE = 'ITEM_FORM_TEMPLATE_USE';
export const ITEM_FORM_DESC_ITEM_TYPE_ADD = 'ITEM_FORM_DESC_ITEM_TYPE_ADD';
export const ITEM_FORM_DESC_ITEM_TYPE_DELETE = 'ITEM_FORM_DESC_ITEM_TYPE_DELETE';
export const ITEM_FORM_VALUE_DELETE = 'ITEM_FORM_VALUE_DELETE';
export const ITEM_FORM_REQUEST = 'ITEM_FORM_REQUEST';
export const ITEM_FORM_RECEIVE = 'ITEM_FORM_RECEIVE';
export const CHANGE_ACCESS_POINT = 'CHANGE_ACCESS_POINT';

export enum ActionTypes {
    FUND_OUTPUT_REQUEST = 'FUND_OUTPUT_REQUEST',
    FUND_OUTPUT_RECEIVE = 'FUND_OUTPUT_RECEIVE',
    FUND_OUTPUT_FILTER_STATE = 'FUND_OUTPUT_FILTER_STATE',
    FUND_OUTPUT_DETAIL_REQUEST = 'FUND_OUTPUT_DETAIL_REQUEST',
    FUND_OUTPUT_DETAIL_RECEIVE = 'FUND_OUTPUT_DETAIL_RECEIVE',
    FUND_OUTPUT_DETAIL_CLEAR = 'FUND_OUTPUT_DETAIL_CLEAR',
    FUND_OUTPUT_SELECT_OUTPUT = 'FUND_OUTPUT_SELECT_OUTPUT',

    FUND_OUTPUT_FILES_REQUEST = 'FUND_OUTPUT_FILES_REQUEST',
    FUND_OUTPUT_FILES_RECEIVE = 'FUND_OUTPUT_FILES_RECEIVE',
    FUND_OUTPUT_FILES_FILTER = 'FUND_OUTPUT_FILES_FILTER',

    FUND_OUTPUT_FUNCTIONS_REQUEST = 'FUND_OUTPUT_FUNCTIONS_REQUEST',
    FUND_OUTPUT_FUNCTIONS_RECEIVE = 'FUND_OUTPUT_FUNCTIONS_RECEIVE',
    FUND_OUTPUT_FUNCTIONS_FILTER = 'FUND_OUTPUT_FUNCTIONS_FILTER',

    FUND_EXTENDED_VIEW = 'FUND_EXTENDED_VIEW',

    FUND_INVALID = 'FUND_INVALID',

    FUND_FUNDS_RECEIVE = 'FUND_FUNDS_RECEIVE',
    FUND_FUNDS_REQUEST = 'FUND_FUNDS_REQUEST',
    FUND_NODES_RECEIVE = 'FUND_NODES_RECEIVE',
    FUND_NODES_REQUEST = 'FUND_NODES_REQUEST',

    USERS_SEARCH = 'USERS_SEARCH',
    USERS_REQUEST = 'USERS_REQUEST',
    USERS_RECEIVE = 'USERS_RECEIVE',
    USERS_SELECT_USER = 'USERS_SELECT_USER',
    USERS_USER_DETAIL_REQUEST = 'USERS_USER_DETAIL_REQUEST',
    USERS_USER_DETAIL_RECEIVE = 'USERS_USER_DETAIL_RECEIVE',

    PERMISSIONS_PERMISSION_CHANGE = 'PERMISSIONS_PERMISSION_CHANGE',
    PERMISSIONS_PERMISSION_ADD = 'PERMISSIONS_PERMISSION_ADD',
    PERMISSIONS_PERMISSION_REMOVE = 'PERMISSIONS_PERMISSION_REMOVE',
    PERMISSIONS_PERMISSION_RECEIVE = 'PERMISSIONS_PERMISSION_RECEIVE',

    GROUP_DELETE = 'GROUP_DELETE',
    GROUPS_SEARCH = 'GROUPS_SEARCH',
    GROUPS_REQUEST = 'GROUPS_REQUEST',
    GROUPS_RECEIVE = 'GROUPS_RECEIVE',
    GROUPS_SELECT_GROUP = 'GROUPS_SELECT_GROUP',
    GROUPS_GROUP_DETAIL_REQUEST = 'GROUPS_GROUP_DETAIL_REQUEST',
    GROUPS_GROUP_DETAIL_RECEIVE = 'GROUPS_GROUP_DETAIL_RECEIVE',

    FUNDS_SEARCH = 'FUNDS_SEARCH',
    FUNDS_FILTER = 'FUNDS_FILTER',
    FUNDS_REQUEST = 'FUNDS_REQUEST',
    FUNDS_RECEIVE = 'FUNDS_RECEIVE',
    FUNDS_FUND_DETAIL_REQUEST = 'FUNDS_FUND_DETAIL_REQUEST',
    FUNDS_FUND_DETAIL_RECEIVE = 'FUNDS_FUND_DETAIL_RECEIVE',
    FUNDS_SELECT_FUND = 'FUNDS_SELECT_FUND',

    FUND_PACKETS_REQUEST = 'FUND_PACKETS_REQUEST',
    FUND_PACKETS_RECEIVE = 'FUND_PACKETS_RECEIVE',
    FUND_PACKETS_FILTER = 'FUND_PACKETS_FILTER',
    FUND_PACKETS_CHANGE_SELECTION = 'FUND_PACKETS_CHANGE_SELECTION',

    FUND_FILES_REQUEST = 'FUND_FILES_REQUEST',
    FUND_FILES_RECEIVE = 'FUND_FILES_RECEIVE',
    FUND_FILES_FILTER = 'FUND_FILES_FILTER',
    FUND_NODE_INCREASE_VERSION = 'FUND_NODE_INCREASE_VERSION',
    FUND_FUND_CHANGE_READ_MODE = 'FUND_FUND_CHANGE_READ_MODE',
    FUND_FUND_TREE_REQUEST = 'FUND_FUND_TREE_REQUEST',
    FUND_FUND_TREE_RECEIVE = 'FUND_FUND_TREE_RECEIVE',
    FUND_FUND_TREE_EXPAND_NODE = 'FUND_FUND_TREE_EXPAND_NODE',
    FUND_FUND_TREE_COLLAPSE_NODE = 'FUND_FUND_TREE_COLLAPSE_NODE',
    FUND_FUND_TREE_FOCUS_NODE = 'FUND_FUND_TREE_FOCUS_NODE',
    FUND_FUND_TREE_COLLAPSE = 'FUND_FUND_TREE_COLLAPSE',
    FUND_FUND_TREE_SELECT_NODE = 'FUND_FUND_TREE_SELECT_NODE',
    FUND_FUND_TREE_FULLTEXT_CHANGE = 'FUND_FUND_TREE_FULLTEXT_CHANGE',
    FUND_FUND_TREE_CONFIGURE = 'FUND_FUND_TREE_CONFIGURE',
    FUND_FUND_TREE_FULLTEXT_RESULT = 'FUND_FUND_TREE_FULLTEXT_RESULT',
    FUND_TREE_AREA_FUNDS_FUND_DETAIL = 'FUND_TREE_AREA_FUNDS_FUND_DETAIL',
    FUND_TREE_AREA_MAIN = 'FUND_TREE_AREA_MAIN',
    FUND_TREE_AREA_MOVEMENTS_LEFT = 'FUND_TREE_AREA_MOVEMENTS_LEFT',
    FUND_TREE_AREA_MOVEMENTS_RIGHT = 'FUND_TREE_AREA_MOVEMENTS_RIGHT',
    FUND_TREE_AREA_DAOS_LEFT = 'FUND_TREE_AREA_DAOS_LEFT',
    FUND_TREE_AREA_DAOS_RIGHT = 'FUND_TREE_AREA_DAOS_RIGHT',
    FUND_TREE_AREA_NODES = 'FUND_TREE_AREA_NODES',
    FUND_TREE_AREA_ALL = 'FUND_TREE_AREA_ALL',

    CUSTOM_FUND_TREE_AREA_NODES = 'CUSTOM_FUND_TREE_AREA_NODES',
    CUSTOM_FUND_ACTION_SELECT_VERSION = 'CUSTOM_FUND_ACTION_SELECT_VERSION',

    FUND_TREE_AREA_COPY = 'FUND_TREE_AREA_COPY',

    FUND_TREE_AREA_USAGE = 'FUND_TREE_AREA_USAGE',

    FUND_FUND_TREE_INVALIDATE = 'FUND_FUND_TREE_INVALIDATE',

    SELECT_FUND_GLOBAL = 'SELECT_FUND_GLOBAL',

    FUND_SUB_NODE_INFO_REQUEST = 'FUND_SUB_NODE_INFO_REQUEST',
    FUND_SUB_NODE_INFO_RECEIVE = 'FUND_SUB_NODE_INFO_RECEIVE',

    FUND_SUB_NODE_REGISTER_RECEIVE = 'FUND_SUB_NODE_REGISTER_RECEIVE',
    FUND_SUB_NODE_REGISTER_REQUEST = 'FUND_SUB_NODE_REGISTER_REQUEST',
    FUND_SUB_NODE_REGISTER_VALUE_ADD = 'FUND_SUB_NODE_REGISTER_VALUE_ADD',
    FUND_SUB_NODE_REGISTER_VALUE_FOCUS = 'FUND_SUB_NODE_REGISTER_VALUE_FOCUS',
    FUND_SUB_NODE_REGISTER_VALUE_CHANGE = 'FUND_SUB_NODE_REGISTER_VALUE_CHANGE',
    FUND_SUB_NODE_REGISTER_VALUE_BLUR = 'FUND_SUB_NODE_REGISTER_VALUE_BLUR',
    FUND_SUB_NODE_REGISTER_VALUE_DELETE = 'FUND_SUB_NODE_REGISTER_VALUE_DELETE',
    FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_CREATE = 'FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_CREATE',
    FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_DELETE = 'FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_DELETE',
    FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_UPDATE = 'FUND_SUB_NODE_REGISTER_VALUE_RESPONSE_UPDATE',
    FUND_SUB_NODE_REGISTER_VALUE_SAVING = 'FUND_SUB_NODE_REGISTER_VALUE_SAVING',

    FUND_SUB_NODE_DAOS_RECEIVE = 'FUND_SUB_NODE_DAOS_RECEIVE',
    FUND_SUB_NODE_DAOS_REQUEST = 'FUND_SUB_NODE_DAOS_REQUEST',

    FUND_SUB_NODE_FORM_REQUEST = 'FUND_SUB_NODE_FORM_REQUEST',
    FUND_SUB_NODE_FORM_RECEIVE = 'FUND_SUB_NODE_FORM_RECEIVE',
    FUND_SUB_NODE_FORM_VALUE_CREATE = 'FUND_SUB_NODE_FORM_VALUE_CREATE',
    FUND_SUB_NODE_FORM_VALUE_CHANGE = 'FUND_SUB_NODE_FORM_VALUE_CHANGE',
    FUND_SUB_NODE_FORM_VALUE_CHANGE_POSITION = 'FUND_SUB_NODE_FORM_VALUE_CHANGE_POSITION',
    FUND_SUB_NODE_FORM_VALUE_CHANGE_RECORD = 'FUND_SUB_NODE_FORM_VALUE_CHANGE_RECORD',
    FUND_SUB_NODE_FORM_VALUE_CHANGE_SPEC = 'FUND_SUB_NODE_FORM_VALUE_CHANGE_SPEC',
    FUND_SUB_NODE_FORM_VALUE_VALIDATE_RESULT = 'FUND_SUB_NODE_FORM_VALUE_VALIDATE_RESULT',
    FUND_SUB_NODE_FORM_VALUE_BLUR = 'FUND_SUB_NODE_FORM_VALUE_BLUR',
    FUND_SUB_NODE_FORM_VALUE_FOCUS = 'FUND_SUB_NODE_FORM_VALUE_FOCUS',
    FUND_SUB_NODE_FORM_VALUE_ADD = 'FUND_SUB_NODE_FORM_VALUE_ADD',
    FUND_SUB_NODE_FORM_VALUE_NOT_IDENTIFIED = 'FUND_SUB_NODE_FORM_VALUE_NOT_IDENTIFIED',
    FUND_SUB_NODE_FORM_VALUE_DELETE = 'FUND_SUB_NODE_FORM_VALUE_DELETE',
    FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_DELETE = 'FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_DELETE',
    FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_ADD = 'FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_ADD',
    FUND_TEMPLATE_USE = 'FUND_TEMPLATE_USE',
    FUND_SUB_NODE_FORM_VALUE_RESPONSE = 'FUND_SUB_NODE_FORM_VALUE_RESPONSE',
    FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_COPY_FROM_PREV_RESPONSE =
    'FUND_SUB_NODE_FORM_DESC_ITEM_TYPE_COPY_FROM_PREV_RESPONSE',
    FUND_SUB_NODE_FORM_OUTPUT_CALC_SWITCH = 'FUND_SUB_NODE_FORM_OUTPUT_CALC_SWITCH',

    FUND_FUND_DATA_GRID_INIT = 'FUND_FUND_DATA_GRID_INIT',
    FUND_FUND_DATA_GRID_FILTER = 'FUND_FUND_DATA_GRID_FILTER',
    FUND_FUND_DATA_GRID_FULLTEXT_RESULT = 'FUND_FUND_DATA_GRID_FULLTEXT_RESULT',
    FUND_FUND_DATA_GRID_FULLTEXT_CLEAR = 'FUND_FUND_DATA_GRID_FULLTEXT_CLEAR',
    FUND_FUND_DATA_GRID_FULLTEXT_EXTENDED = 'FUND_FUND_DATA_GRID_FULLTEXT_EXTENDED',
    FUND_FUND_DATA_GRID_FULLTEXT_NEXT_ITEM = 'FUND_FUND_DATA_GRID_FULLTEXT_NEXT_ITEM',
    FUND_FUND_DATA_GRID_FULLTEXT_PREV_ITEM = 'FUND_FUND_DATA_GRID_FULLTEXT_PREV_ITEM',
    FUND_FUND_DATA_GRID_FILTER_REQUEST = 'FUND_FUND_DATA_GRID_FILTER_REQUEST',
    FUND_FUND_DATA_GRID_FILTER_RECEIVE = 'FUND_FUND_DATA_GRID_FILTER_RECEIVE',
    FUND_FUND_DATA_GRID_FILTER_CHANGE = 'FUND_FUND_DATA_GRID_FILTER_CHANGE',
    FUND_FUND_DATA_GRID_FILTER_SET = 'FUND_FUND_DATA_GRID_FILTER_SET',
    FUND_FUND_DATA_GRID_FILTER_CLEAR_ALL = 'FUND_FUND_DATA_GRID_FILTER_CLEAR_ALL',
    FUND_FUND_DATA_GRID_PREPARE_EDIT = 'FUND_FUND_DATA_GRID_PREPARE_EDIT',
    FUND_FUND_DATA_GRID_DATA_REQUEST = 'FUND_FUND_DATA_GRID_DATA_REQUEST',
    FUND_FUND_DATA_GRID_DATA_RECEIVE = 'FUND_FUND_DATA_GRID_DATA_RECEIVE',
    FUND_FUND_DATA_GRID_DATA_ERROR = 'FUND_FUND_DATA_GRID_DATA_ERROR',
    FUND_FUND_DATA_GRID_COLUMN_SIZE = 'FUND_FUND_DATA_GRID_COLUMN_SIZE',
    FUND_FUND_DATA_GRID_COLUMNS_SETTINGS = 'FUND_FUND_DATA_GRID_COLUMNS_SETTINGS',

    FUND_FUND_NODES_POLICY_REQUEST = 'FUND_FUND_NODES_POLICY_REQUEST',
    FUND_FUND_NODES_POLICY_RECEIVE = 'FUND_FUND_NODES_POLICY_RECEIVE',

    FUND_NODE_INFO_REQUEST = 'FUND_NODE_INFO_REQUEST',
    FUND_NODE_INFO_RECEIVE = 'FUND_NODE_INFO_RECEIVE',
    FUND_NODE_INFO_INVALIDATE = 'FUND_NODE_INFO_INVALIDATE',

    FUND_SELECT_FUND_TAB = 'FUND_SELECT_FUND_TAB',
    FUND_CLOSE_FUND_TAB = 'FUND_CLOSE_FUND_TAB',

    FUND_SEARCH_FULLTEXT_CHANGE = 'FUND_SEARCH_FULLTEXT_CHANGE',
    FUND_SEARCH_FULLTEXT_REQUEST = 'FUND_SEARCH_FULLTEXT_REQUEST',
    FUND_SEARCH_FULLTEXT_RECEIVE = 'FUND_SEARCH_FULLTEXT_RECEIVE',
    FUND_SEARCH_EXPAND_FUND = 'FUND_SEARCH_EXPAND_FUND',
    FUND_SEARCH_FUND_REQUEST = 'FUND_SEARCH_FUND_REQUEST',
    FUND_SEARCH_FUND_RECEIVE = 'FUND_SEARCH_FUND_RECEIVE',

    FUND_FUND_SELECT_NODE_TAB = 'FUND_FUND_SELECT_NODE_TAB',
    FUND_FUND_CLOSE_NODE_TAB = 'FUND_FUND_CLOSE_NODE_TAB',
    FUND_FUND_SELECT_SUBNODE = 'FUND_FUND_SELECT_SUBNODE',
    FUND_FUND_SUBNODES_NEXT = 'FUND_FUND_SUBNODES_NEXT',
    FUND_FUND_SUBNODES_PREV = 'FUND_FUND_SUBNODES_PREV',
    FUND_FUND_SUBNODES_NEXT_PAGE = 'FUND_FUND_SUBNODES_NEXT_PAGE',
    FUND_FUND_SUBNODES_PREV_PAGE = 'FUND_FUND_SUBNODES_PREV_PAGE',
    FUND_FUND_SUBNODES_FULLTEXT_SEARCH = 'FUND_FUND_SUBNODES_FULLTEXT_SEARCH',
    FUND_FUND_SUBNODES_FULLTEXT_RESULT = 'FUND_FUND_SUBNODES_FULLTEXT_RESULT',
    FUND_FUND_APPROVE_VERSION = 'FUND_FUND_APPROVE_VERSION',

    /**
 * Uživatelské nastavení pro JP
 */
    NODE_DESC_ITEM_TYPE_LOCK = 'NODE_DESC_ITEM_TYPE_LOCK',
    NODE_DESC_ITEM_TYPE_UNLOCK = 'NODE_DESC_ITEM_TYPE_UNLOCK',
    NODE_DESC_ITEM_TYPE_UNLOCK_ALL = 'NODE_DESC_ITEM_TYPE_UNLOCK_ALL',
    NODE_DESC_ITEM_COPY_ALL = 'NODE_DESC_ITEM_COPY_ALL',
    NODE_DESC_ITEM_TYPE_COPY_ALL = 'NODE_DESC_ITEM_TYPE_COPY_ALL',
    NODE_DESC_ITEM_TYPE_COPY = 'NODE_DESC_ITEM_TYPE_COPY',
    NODE_DESC_ITEM_TYPE_NOCOPY = 'NODE_DESC_ITEM_TYPE_NOCOPY',
    SHOW_REGISTER_JP = 'SHOW_REGISTER_JP',

    /**
 * Přihlášený uživatel a jeho informace.
 */
    USER_DETAIL_CHANGE = 'USER_DETAIL_CHANGE',
    USER_DETAIL_REQUEST = 'USER_DETAIL_REQUEST',
    USER_DETAIL_REQUEST_SETTINGS = 'USER_DETAIL_REQUEST_SETTINGS',
    USER_DETAIL_RESPONSE_SETTINGS = 'USER_DETAIL_RESPONSE_SETTINGS',
    USER_DETAIL_CLEAR = 'USER_DETAIL_CLEAR',

    /**
 * JP akce
 */
    FUND_NODE_CHANGE = 'FUND_NODE_CHANGE',

    /**
 * Obaly pro FUND
 */
    PACKETS_REQUEST = 'PACKETS_REQUEST',
    PACKETS_RECEIVE = 'PACKETS_RECEIVE',
    CHANGE_PACKETS = 'CHANGE_PACKETS',
    CHANGE_FILES = 'CHANGE_FILES',

    /**
 * Toastr
 **/

    TOASTR_ADD = 'TOASTR_ADD',
    TOASTR_REMOVE = 'TOASTR_REMOVE',

    /**
 * Registry.
 */

    REGISTRY_ARR_RESET = 'REGISTRY_ARR_RESET',
    REGISTRY_CLEAR_SEARCH = 'REGISTRY_CLEAR_SEARCH',
    REGISTRY_RELOAD_NAVIGATION = 'REGISTRY_RELOAD_NAVIGATION',
    REGISTRY_LIST_REQUEST = 'REGISTRY_LIST_REQUEST',
    REGISTRY_LIST_RECEIVE = 'REGISTRY_LIST_RECEIVE',
    REGISTRY_SELECT = 'REGISTRY_SELECT',
    REGISTRY_CHANGED_TYPES_ID = 'REGISTRY_CHANGED_TYPES_ID',
    REGISTRY_RECORD_SELECT = 'REGISTRY_RECORD_SELECT',
    REGISTRY_RECORD_SEARCH = 'REGISTRY_RECORD_SEARCH',
    REGISTRY_RECORD_DETAIL_RECEIVE = 'REGISTRY_RECORD_DETAIL_RECEIVE',
    REGISTRY_RECORD_DETAIL_REQUEST = 'REGISTRY_RECORD_DETAIL_REQUEST',
    REGISTRY_RECORD_DETAIL_CHANGE = 'REGISTRY_RECORD_DETAIL_CHANGE',
    REGISTRY_RECORD_DETAIL_CLEAR = 'REGISTRY_RECORD_DETAIL_CLEAR',
    REGISTRY_RECORD_UPDATED = 'REGISTRY_RECORD_UPDATED',
    REGISTRY_RECORD_REMOVE = 'REGISTRY_RECORD_REMOVE',
    REGISTRY_RECORD_NOTE_UPDATED = 'REGISTRY_RECORD_NOTE_UPDATED',
    REGISTRY_RECORD_TYPES_REQUEST = 'REGISTRY_RECORD_TYPES_REQUEST',
    REGISTRY_RECORD_TYPES_RECEIVE = 'REGISTRY_RECORD_TYPES_RECEIVE',

    /**
 * Global.
 */
    GLOBAL_GET_OBJECT_INFO = 'GLOBAL_GET_OBJECT_INFO',
    GLOBAL_CONTEXT_MENU_SHOW = 'GLOBAL_CONTEXT_MENU_SHOW',
    GLOBAL_CONTEXT_MENU_HIDE = 'GLOBAL_CONTEXT_MENU_HIDE',
    GLOBAL_MODAL_DIALOG_SHOW = 'GLOBAL_MODAL_DIALOG_SHOW',
    GLOBAL_MODAL_DIALOG_HIDE = 'GLOBAL_MODAL_DIALOG_HIDE',
    GLOBAL_INIT_FORM_DATA = 'GLOBAL_INIT_FORM_DATA',
    GLOBAL_WEB_SOCKET_CONNECT = 'GLOBAL_WEB_SOCKET_CONNECT',
    GLOBAL_WEB_SOCKET_DISCONNECT = 'GLOBAL_WEB_SOCKET_DISCONNECT',
    GLOBAL_SPLITTER_RESIZE = 'GLOBAL_SPLITTER_RESIZE',

    SET_FOCUS = 'SET_FOCUS',

    DEVELOPER_SET = 'DEVELOPER_SET',
    DEVELOPER_SCENARIOS_RECEIVED = 'DEVELOPER_SCENARIOS_RECEIVED',
    DEVELOPER_SCENARIOS_FETCHING = 'DEVELOPER_SCENARIOS_FETCHING',
    DEVELOPER_SCENARIOS_DIRTY = 'DEVELOPER_SCENARIOS_DIRTY',

    /**
 * Ukládání a načítání store.
 */
    STORE_SAVE = 'STORE_SAVE',
    STORE_LOAD = 'STORE_LOAD',
    STORE_STATE_DATA = 'STORE_STATE_DATA',
    STORE_STATE_DATA_INIT = 'STORE_STATE_DATA_INIT',

    /**
 * scopes
 */
    SCOPES_PREPARE_SCOPES_DATE = 'SCOPES_PREPARE_SCOPES_DATE',
    /**
 * Router.
 */
    ROUTER_NAVIGATE = 'ROUTER_NAVIGATE',
    ROUTER_NAVIGATE_CLEAR = 'ROUTER_NAVIGATE_CLEAR',

    /**
 * Admin - Packages
 */
    ADMIN_PACKAGES_REQUEST = 'ADMIN_PACKAGES_REQUEST', // dotaz na načtení balíčk,
    ADMIN_PACKAGES_RECEIVE = 'ADMIN_PACKAGES_RECEIVE', // odpověď na načtení balíčk,
    ADMIN_PACKAGES_DELETE_REQUEST = 'ADMIN_PACKAGES_DELETE_REQUEST', // dotaz na smazání balíčk,
    ADMIN_PACKAGES_DELETE_RECEIVE = 'ADMIN_PACKAGES_DELETE_RECEIVE', // odpověď na smazání balíčk,
    ADMIN_PACKAGES_IMPORT_REQUEST = 'ADMIN_PACKAGES_IMPORT_REQUEST', // dotaz na nahrání balíčk,
    ADMIN_PACKAGES_IMPORT_RECEIVE = 'ADMIN_PACKAGES_IMPORT_RECEIVE', // odpověď na nahrání balíčk,

    /**
 * Admin - Fulltext
 */
    ADMIN_FULLTEXT_REINDEXING_REQUEST = 'ADMIN_FULLTEXT_REINDEXING_REQUEST', // požadavek na reindexac,
    ADMIN_FULLTEXT_REINDEXING_STATE_REQUEST = 'ADMIN_FULLTEXT_REINDEXING_STATE_REQUEST', // dotaz na průběh indexac,
    ADMIN_FULLTEXT_REINDEXING_STATE_RECEIVE = 'ADMIN_FULLTEXT_REINDEXING_STATE_RECEIVE', // odpověď na průběh indexac,

    /**
 * Ref tables.
 */
    REF_RULE_SET_REQUEST = 'REF_RULE_SET_REQUEST',
    REF_RULE_SET_RECEIVE = 'REF_RULE_SET_RECEIVE',
    REF_INSTITUTIONS_REQUEST = 'REF_INSTITUTIONS_REQUEST',
    REF_INSTITUTIONS_RECEIVE = 'REF_INSTITUTIONS_RECEIVE',
    REF_RUL_DATA_TYPES_REQUEST = 'REF_RUL_DATA_TYPES_REQUEST',
    REF_RUL_DATA_TYPES_RECEIVE = 'REF_RUL_DATA_TYPES_RECEIVE',
    REF_RECORD_TYPES_REQUEST = 'REF_RECORD_TYPES_REQUEST',
    REF_RECORD_TYPES_RECEIVE = 'REF_RECORD_TYPES_RECEIVE',
    REF_CALENDAR_TYPES_REQUEST = 'REF_CALENDAR_TYPES_REQUEST',
    REF_CALENDAR_TYPES_RECEIVE = 'REF_CALENDAR_TYPES_RECEIVE',
    REF_TEMPLATES_REQUEST = 'REF_TEMPLATES_REQUEST',
    REF_TEMPLATES_RECEIVE = 'REF_TEMPLATES_RECEIVE',
    REF_PACKET_TYPES_REQUEST = 'REF_PACKET_TYPES_REQUEST',
    REF_PACKET_TYPES_RECEIVE = 'REF_PACKET_TYPES_RECEIVE',
    REF_REGISTER_TYPES_REQUEST = 'REF_REGISTER_TYPES_REQUEST',
    REF_REGISTER_TYPES_RECEIVE = 'REF_REGISTER_TYPES_RECEIVE',
    REF_SCOPES_TYPES_REQUEST = 'REF_SCOPES_TYPES_REQUEST',
    REF_SCOPES_TYPES_RECEIVE = 'REF_SCOPES_TYPES_RECEIVE',
    REF_SCOPES_TYPES_FETCHING = 'REF_SCOPES_TYPES_FETCHING',
    REF_SCOPES_TYPES_DIRTY = 'REF_SCOPES_TYPES_DIRTY',
    REF_DESC_ITEM_TYPES_REQUEST = 'REF_DESC_ITEM_TYPES_REQUEST',
    REF_DESC_ITEM_TYPES_RECEIVE = 'REF_DESC_ITEM_TYPES_RECEIVE',
    REF_VISIBLE_POLICY_TYPES_REQUEST = 'REF_VISIBLE_POLICY_TYPES_REQUEST',
    REF_VISIBLE_POLICY_TYPES_RECEIVE = 'REF_VISIBLE_POLICY_TYPES_RECEIVE',
    REF_OUTPUT_TYPES_RECEIVE = 'REF_OUTPUT_TYPES_RECEIVE',
    REF_OUTPUT_TYPES_REQUEST = 'REF_OUTPUT_TYPES_REQUEST',
    REF_EXTERNAL_SYSTEMS_RECEIVE = 'REF_EXTERNAL_SYSTEMS_RECEIVE',
    REF_EXTERNAL_SYSTEMS_REQUEST = 'REF_EXTERNAL_SYSTEMS_REQUEST',
    REF_EXTERNAL_SYSTEMS_INVALID = 'REF_EXTERNAL_SYSTEMS_INVALID',

    REF_STRUCTURE_TYPES_DIRTY = 'REF_STRUCTURE_TYPES_DIRTY',
    REF_STRUCTURE_TYPES_FETCHING = 'REF_STRUCTURE_TYPES_FETCHING',
    REF_STRUCTURE_TYPES_RECEIVE = 'REF_STRUCTURE_TYPES_RECEIVE',

    REF_AP_TYPES_REQUEST = 'REF_AP_TYPES_REQUEST',
    REF_AP_TYPES_RECEIVE = 'REF_AP_TYPES_RECEIVE',

    REF_PART_TYPES_REQUEST = 'REF_PART_TYPES_REQUEST',
    REF_PART_TYPES_RECEIVE = 'REF_PART_TYPES_RECEIVE',

    /**
 * Akce od websocketů.
 */
    FUND_SUBNODE_UPDATE = 'FUND_SUBNODE_UPDATE',
    CHANGE_NODE_REQUESTS = 'CHANGE_NODE_REQUESTS',
    CHANGE_CONFORMITY_INFO = 'CHANGE_CONFORMITY_INFO',
    CHANGE_INDEXING_FINISHED = 'CHANGE_INDEXING_FINISHED',
    CHANGE_PACKAGE = 'CHANGE_PACKAGE',
    CHANGE_INSTITUTION = 'CHANGE_INSTITUTION',
    CHANGE_NODES = 'CHANGE_NODES',
    CHANGE_OUTPUTS = 'CHANGE_OUTPUTS',
    CHANGE_STRUCTURE = 'CHANGE_STRUCTURE',
    CHANGE_FUND_ACTION = 'CHANGE_FUND_ACTION',
    CHANGE_DELETE_LEVEL = 'CHANGE_DELETE_LEVEL',
    CHANGE_ADD_LEVEL = 'CHANGE_ADD_LEVEL',
    CHANGE_APPROVE_VERSION = 'CHANGE_APPROVE_VERSION',
    CHANGE_MOVE_LEVEL = 'CHANGE_MOVE_LEVEL',
    FUND_NODES_MOVE_START = 'FUND_NODES_MOVE_START',
    FUND_NODES_MOVE_STOP = 'FUND_NODES_MOVE_STOP',
    CHANGE_REGISTRY_UPDATE = 'CHANGE_REGISTRY_UPDATE',
    CHANGE_FUND = 'CHANGE_FUND',
    CHANGE_FUND_RECORD = 'CHANGE_FUND_RECORD',
    CHANGE_VISIBLE_POLICY = 'CHANGE_VISIBLE_POLICY',
    CHANGE_USER = 'CHANGE_USER',
    CHANGE_GROUP = 'CHANGE_GROUP',

    DELETE_FUND = 'DELETE_FUND',

    /**
 * Output related actions
 */
    OUTPUT_CHANGES = 'OUTPUT_CHANGES',
    OUTPUT_CHANGES_DETAIL = 'OUTPUT_CHANGES_DETAIL',
    OUTPUT_INCREASE_VERSION = 'OUTPUT_INCREASE_VERSION',
    OUTPUT_STATE_CHANGE = 'OUTPUT_STATE_CHANGE',

    /**
 * Bulk Actions
 */
    BULK_ACTIONS_DATA_LOADING = 'BULK_ACTIONS_DATA_LOADING',
    BULK_ACTIONS_RECEIVED_DATA = 'BULK_ACTIONS_RECEIVED_DATA',
    BULK_ACTIONS_VERSION_VALIDATE_RECEIVED_DATA = 'BULK_ACTIONS_VERSION_VALIDATE_RECEIVED_DATA',
    BULK_ACTIONS_RECEIVED_STATE = 'BULK_ACTIONS_RECEIVED_STATE',
    BULK_ACTIONS_STATE_CHANGE = 'BULK_ACTIONS_STATE_CHANGE',
    BULK_ACTIONS_STATE_IS_DIRTY = 'BULK_ACTIONS_STATE_IS_DIRTY',

    /**
 * Fund actions
 */
    FUND_ACTION_ACTION_SELECT = 'FUND_ACTION_ACTION_SELECT',
    FUND_ACTION_CONFIG_REQUEST = 'FUND_ACTION_CONFIG_REQUEST',
    FUND_ACTION_CONFIG_RECEIVE = 'FUND_ACTION_CONFIG_RECEIVE',
    FUND_ACTION_ACTION_DETAIL_REQUEST = 'FUND_ACTION_ACTION_DETAIL_REQUEST',
    FUND_ACTION_ACTION_DETAIL_RECEIVE = 'FUND_ACTION_ACTION_DETAIL_RECEIVE',
    FUND_ACTION_LIST_REQUEST = 'FUND_ACTION_LIST_REQUEST',
    FUND_ACTION_LIST_RECEIVE = 'FUND_ACTION_LIST_RECEIVE',
    FUND_ACTION_FORM_SHOW = 'FUND_ACTION_FORM_SHOW',
    FUND_ACTION_FORM_HIDE = 'FUND_ACTION_FORM_HIDE',
    FUND_ACTION_FORM_RESET = 'FUND_ACTION_FORM_RESET',
    FUND_ACTION_FORM_CHANGE = 'FUND_ACTION_FORM_CHANGE',
    FUND_ACTION_FORM_SUBMIT = 'FUND_ACTION_FORM_SUBMIT',

    /**
 *
 */
    FUND_VERSION_VALIDATION_LOAD = 'FUND_VERSION_VALIDATION_LOAD',
    FUND_VERSION_VALIDATION_RECEIVED = 'FUND_VERSION_VALIDATION_RECEIVED',
    FUND_VERSION_VALIDATION_ERROR_NEXT_REQUEST = 'FUND_VERSION_VALIDATION_ERROR_NEXT_REQUEST',
    FUND_VERSION_VALIDATION_ERROR_NEXT_RECEIVE = 'FUND_VERSION_VALIDATION_ERROR_NEXT_RECEIVE',
    FUND_VERSION_VALIDATION_ERROR_PREVIOUS_REQUEST = 'FUND_VERSION_VALIDATION_ERROR_PREVIOUS_REQUEST',
    FUND_VERSION_VALIDATION_ERROR_PREVIOUS_RECEIVE = 'FUND_VERSION_VALIDATION_ERROR_PREVIOUS_RECEIVE',

    LOGIN_SUCCESS = 'LOGIN_SUCCESS',
    LOGIN_FAIL = 'LOGIN_FAIL',
    LOGOUT = 'LOGOUT',

    VISIBLE_POLICY_REQUEST = 'VISIBLE_POLICY_REQUEST',
    VISIBLE_POLICY_RECEIVE = 'VISIBLE_POLICY_RECEIVE',

    SET_VISIBLE_POLICY_REQUEST = 'SET_VISIBLE_POLICY_REQUEST',
    SET_VISIBLE_POLICY_RECEIVE = 'SET_VISIBLE_POLICY_RECEIVE',

    /**
 * Záložky
 */
    TAB_SELECT = 'TAB_SELECT',

    /**
 * Status store
 */
    STATUS_SAVING = 'STATUS_SAVING',
    STATUS_SAVED = 'STATUS_SAVED',

    /**
 * Smazání nodů - při UNDO
 */
    NODES_DELETE = 'NODES_DELETE',

    CHANGE_DAOS = 'CHANGE_DAOS',

    /**
 * Structure
 */
    STRUCTURE_NODE_FORM_REQUEST = 'STRUCTURE_NODE_FORM_REQUEST',
    STRUCTURE_NODE_FORM_RECEIVE = 'STRUCTURE_NODE_FORM_RECEIVE',
    STRUCTURE_NODE_FORM_SET_DATA = 'STRUCTURE_NODE_FORM_SET_DATA',
    STRUCTURE_NODE_FORM_SELECT_ID = 'STRUCTURE_NODE_FORM_SELECT_ID',

    /**
 * Item form
 */
    ITEM_FORM_CHANGE_READ_MODE = 'ITEM_FORM_CHANGE_READ_MODE',
    ITEM_FORM_VALUE_VALIDATE_RESULT = 'ITEM_FORM_VALUE_VALIDATE_RESULT',
    ITEM_FORM_FORM_VALUE_CHANGE_POSITION = 'ITEM_FORM_FORM_VALUE_CHANGE_POSITION',
    ITEM_FORM_VALUE_CHANGE = 'ITEM_FORM_VALUE_CHANGE',
    ITEM_FORM_VALUE_CHANGE_RECORD = 'ITEM_FORM_VALUE_CHANGE_RECORD',
    ITEM_FORM_VALUE_CHANGE_SPEC = 'ITEM_FORM_VALUE_CHANGE_SPEC',
    ITEM_FORM_VALUE_BLUR = 'ITEM_FORM_VALUE_BLUR',
    ITEM_FORM_VALUE_FOCUS = 'ITEM_FORM_VALUE_FOCUS',
    ITEM_FORM_VALUE_CREATE = 'ITEM_FORM_VALUE_CREATE',
    ITEM_FORM_VALUE_ADD = 'ITEM_FORM_VALUE_ADD',
    ITEM_FORM_DESC_ITEM_TYPE_COPY_FROM_PREV_RESPONSE = 'ITEM_FORM_DESC_ITEM_TYPE_COPY_FROM_PREV_RESPONSE',
    ITEM_FORM_OUTPUT_CALC_SWITCH = 'ITEM_FORM_OUTPUT_CALC_SWITCH',
    ITEM_FORM_VALUE_RESPONSE = 'ITEM_FORM_VALUE_RESPONSE',
    ITEM_FORM_TEMPLATE_USE = 'ITEM_FORM_TEMPLATE_USE',
    ITEM_FORM_DESC_ITEM_TYPE_ADD = 'ITEM_FORM_DESC_ITEM_TYPE_ADD',
    ITEM_FORM_DESC_ITEM_TYPE_DELETE = 'ITEM_FORM_DESC_ITEM_TYPE_DELETE',
    ITEM_FORM_VALUE_DELETE = 'ITEM_FORM_VALUE_DELETE',
    ITEM_FORM_REQUEST = 'ITEM_FORM_REQUEST',
    ITEM_FORM_RECEIVE = 'ITEM_FORM_RECEIVE',
    CHANGE_ACCESS_POINT = 'CHANGE_ACCESS_POINT',
}
